















































































import { Component, Vue, Watch, Prop, Provide } from 'vue-property-decorator';
import * as api from '@/api';
import {
  CommonAuditStatus,
  TrainClassDto,
  // ClassSolutionSignInSchedule,
} from '@/api/models';
import confirmDialog from '@/components/common/confirmDialog.vue';
import confirmFeedback from '@/components/common/confirmFeedback.vue';
import moment from 'moment';
@Component({ components: { confirmDialog, confirmFeedback } })
export default class SignList extends Vue {
  @Prop() signStatus: string;
  errorMsg: string = '';
  dialogShow: boolean = false;
  feedbackShow: boolean = false;
  dialogType: string = '';
  feedbackType: string = '';
  successStatu: boolean = false;
  crrClassItem: any = {};
  //时间、地点签到确认框专用
  signTime: string = '';
  signAddress: string = '';
  loading: boolean = false;
  finished: boolean = false;
  listData: any = [];
  otherStatuData: any = [];
  shzData: any = [];
  wtgData: any = [];
  @Watch('signStatus', { immediate: true })
  async onTrainStatusChangeAsync(val: string) {
    this.getListData();
    this.getOtherStatuData();
  }
  async getListData() {
    // this.loading = true;
    // try {
    //   this.listData = [];
    //   if (this.signStatus == "补签") {
    //     const { data } = await api.SolutionSignIn.getPersonalWaitSingInBySolutionId_GET({
    //       solutionId: "",
    //     });
    //     this.listData = data!;
    //   } else {
    //     const { data } = await api.SolutionSignIn.getSigninRecords_GET({
    //       isPersonal: true,
    //       solutionId: "",
    //       state: CommonAuditStatus.已通过,
    //       studentName: "",
    //       pageSize: 10000,
    //     });
    //     this.listData = data!.items;
    //   }
    // } finally {
    //   this.loading = false;
    //   this.finished = true;
    // }
  }
  async getOtherStatuData() {
    // this.loading = true;
    // try {
    //   if (this.signStatus == "补签") {
    //     {
    //       const { data } = await api.SolutionSignIn.getSigninRecords_GET({
    //         isPersonal: true,
    //         solutionId: "",
    //         state: CommonAuditStatus.审核中,
    //       });
    //       this.shzData = data!.items;
    //     }
    //     {
    //       const { data } = await api.SolutionSignIn.getSigninRecords_GET({
    //         isPersonal: true,
    //         solutionId: "",
    //         state: CommonAuditStatus.未通过,
    //       });
    //       this.wtgData = data!.items;
    //     }
    //     this.shzData.forEach((item: any) => {
    //       this.otherStatuData.push(item);
    //     });
    //     this.wtgData.forEach((item: any) => {
    //       this.otherStatuData.push(item);
    //     });
    //   }
    // } finally {
    //   this.loading = false;
    //   this.finished = true;
    // }
  }
  //补签
  signSubmit(item: any) {
    this.dialogShow = true;
    this.dialogType = '签到';
    this.signTime = moment(new Date()).format('YYYY-MM-DD HH:mm');
    this.signAddress = item.address!;
    this.crrClassItem = item;
  }

  //确认签到回调事件
  async confirmSubmit(val: any) {
    // this.dialogShow = false;
    // this.feedbackShow = true;
    // this.loading = true;
    // //系统返回提交状态
    // try {
    //   const { data, success, message } = await api.SolutionSignIn.studentSingIn_POST({
    //     openClassSolutionId: this.crrClassItem.classSolutionId,
    //     signInScheduleId: this.crrClassItem.signInScheduleId,
    //   });
    //   if (success) {
    //     this.successStatu = true;
    //     this.listData.forEach((item: any, index: number) => {
    //       if (item.classSolutionId == this.crrClassItem.classSolutionId) {
    //         this.$set(this.listData[index], "auditStatus", CommonAuditStatus.审核中);
    //       }
    //     });
    //   } else {
    //     this.successStatu = false;
    //     this.errorMsg = message;
    //   }
    // } finally {
    //   this.loading = false;
    //   this.finished = true;
    // }
    // if (!this.successStatu) {
    //   this.errorMsg = "补签到失败";
    // }
    // this.feedbackType = "签到";
  }
  //取消签到回调事件
  confirmCancle() {
    this.dialogShow = false;
  }
  //关闭提交状态对话框回调事件
  feedbaclCancle() {
    this.feedbackShow = false;
  }
}
